module.exports = __webpack_public_path__ + "img/logo-white.97c76c1b.png";